import { bytesToSize, generateId } from '../../../shared/utils';
import { checkBlackListedFiles, checkHiddenFiles } from '../../import/helpers/normalizeItems';

/**
 * Make items
 * @param {Object[]} files
 * @param {Object} inbox
 * @returns {Object}
 */
export default function normalizeFiles(files, inbox) {
  return [...files].reduce((result, file) => {
    if (!file.size) {
      /** if zero file size or file size is unknown */
      result.corruptedFiles.push(file);
    } else if (checkBlackListedFiles(file.name, inbox.user.settings?.extensionsBlackList || inbox.user.team?.settings?.extensionsBlackList)) {
      result.blackListedFiles.push(file);
    } else if (checkHiddenFiles(file.name)) {
      result.hiddenFiles.push(file);
    } else {
      result.normalizedFiles.push({
        id: generateId(),
        shortSize: bytesToSize(file.size),
        file,
        inbox,
        name: file.name,
        path: `Inboxes/${inbox.name}`,
      });
    }
    return result;
  }, {
    normalizedFiles: [], corruptedFiles: [], blackListedFiles: [], hiddenFiles: [],
  });
}
